import { render, staticRenderFns } from "./EventiMenuEdit.vue?vue&type=template&id=c2bf5c8e"
import script from "./EventiMenuEdit.vue?vue&type=script&lang=js"
export * from "./EventiMenuEdit.vue?vue&type=script&lang=js"
import style0 from "./EventiMenuEdit.vue?vue&type=style&index=0&id=c2bf5c8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports